module.exports = __webpack_public_path__ + "media/images/icon_del-23ea94b86f0af9bf6fd26df684c98afc.svg";